var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table sort ui-sortable oc-sort" }, [
    _c("tfoot", [
      _c("tr", [
        _c(
          "td",
          { staticClass: "oc-settings__add-row", attrs: { colspan: "6" } },
          [
            _c(
              "button",
              {
                staticClass: "oc-settings-btn",
                on: {
                  click: function($event) {
                    return _vm.addItem()
                  }
                }
              },
              [_vm._v("Добавить тему")]
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      {
        directives: [
          {
            name: "sortable",
            rawName: "v-sortable",
            value: _vm.getSortParams(),
            expression: "getSortParams()"
          }
        ]
      },
      _vm._l(_vm.settings.form_topics, function(item, index) {
        return _c(
          "tr",
          { key: index, staticStyle: { opacity: "1", "z-index": "0" } },
          [
            _vm._m(0, true),
            _vm._v(" "),
            _c("td", { staticClass: "oc-table__row_min" }, [
              _c(
                "span",
                { staticClass: "hint" },
                [
                  _c("checkbox", {
                    attrs: { checked: !!+item.active },
                    on: {
                      change: function(val) {
                        item.active = +val
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: item.topic,
                    expression: "item.topic"
                  }
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  name: "settings[form_topics][][topic]",
                  placeholder: "Тема"
                },
                domProps: { value: item.topic },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(item, "topic", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("br")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "oc-col_min-width" }, [
              _vm.settings.form_topics.length > 1
                ? _c(
                    "span",
                    {
                      staticClass: "oc-clickable",
                      on: {
                        click: function($event) {
                          return _vm.deleteItem(index)
                        }
                      }
                    },
                    [_c("i", { staticClass: "oc-icon16 ico-delete" })]
                  )
                : _vm._e()
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "oc-table__row_min" }, [
      _c("i", { staticClass: "icon16 sort sort-handle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-adfd12ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adfd12ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/form/FormTopic.vue
// module id = 116
// module chunks = 0